var styles = {"badgeWrapper":"VBG__DS__badge-module__2bxmM","showBorder":"VBG__DS__badge-module__2tJ0i","badgeContent":"VBG__DS__badge-module__1duqz","child":"VBG__DS__badge-module__gRPoT","tooltip":"VBG__DS__badge-module__PMN-N","icon":"VBG__DS__badge-module__3d2Vk"};

export { styles as default };
